const enFilterWords: string[] = [
  'a',
  'an',
  'the',
  'over',
  'in',
  'as',
  'at',
  'to',
  'of',
  'on',
  'onto',
  'by',
  'with',
  'via',
  'for',
  'and',
  'nor',
  'but',
  'or',
  'yet',
  'so',
  'I',
  'you',
  'he',
  'she',
  'it',
  'we',
  'they',
  'me',
  'him',
  'her',
  'us',
  'them',
  'mine',
  'yours',
  'his',
  'hers',
  'its',
  'ours',
  'theirs',
  'this',
  'that',
  'these',
  'those',
  'who',
  'whom',
  'which',
  'what',
];

const traditionalChineseFilterWords: string[] = [
  '在',
  '由',
  '向',
  '至',
  '與',
  '關於',
  '對於',
  '的',
  '了',
  '著',
  '嗎',
  '呢',
  '啊',
  '呀',
  '吧',
  '和',
  '但',
  '或',
  '因為',
  '所以',
  '雖然',
  '然後',
  '如果',
  '及',
  '而且',
  '是',
  '有',
  '這',
  '那',
  '也',
  '不',
  '很',
  '可以',
  '要',
  '就',
  '而',
  '還',
  '會',
  '個',
  '來',
  '去',
  '才',
  '為',
  '之',
  '與',
  '若',
  '即',
  '之',
  '如',
  '若',
  '過',
  '又',
  '於',
  '再',
  '各',
  '用',
  '所',
  '如何',
  '仍',
  '而已',
  '卻',
  '之間',
];

const simplifiedChineseFilterWords: string[] = [
  '在',
  '由',
  '向',
  '至',
  '与',
  '关于',
  '对于',
  '的',
  '了',
  '著',
  '吗',
  '呢',
  '啊',
  '呀',
  '吧',
  '和',
  '但',
  '或',
  '因为',
  '所以',
  '虽然',
  '然后',
  '如果',
  '及',
  '而且',
  '是',
  '有',
  '这',
  '那',
  '也',
  '不',
  '很',
  '可以',
  '要',
  '就',
  '而',
  '还',
  '会',
  '个',
  '来',
  '去',
  '才',
  '为',
  '之',
  '与',
  '若',
  '即',
  '之',
  '如',
  '若',
  '过',
  '又',
  '于',
  '再',
  '各',
  '用',
  '所',
  '如何',
  '仍',
  '而已',
  '却',
  '之间',
];

const japaneseFilterWords: string[] = [
  'から',
  'だけ',
  'まで',
  'ので',
  'のに',
  'へと',
  'として',
  'によって',
  'に対して',
  'に関して',
  'について',
  'によると',
  'にて',
  'と共に',
  'に対する',
  'による',
  'に反して',
  'に違いない',
  'に関わる',
  'に基づいて',
  'に伴う',
  'において',
  'により',
  'に従って',
  'より',
  'までに',
  'までは',
  'をさして',
  'のために',
  'ために',
  'ため',
  'ても',
  'ては',
  'たら',
  'たり',
  'こそ',
  'しか',
  'ばかり',
  'ばっかり',
  'ほど',
  'なり',
  'なあ',
  'しかし',
  'の間で',
  'の間に',
  '間に',
  '後に',
  'あと',
  'あとに',
  'あとで',
  '以下',
  '以上',
  '次の',
  '後ろに',
  '上記の',
  '下に',
  '上に',
  'にもかかわらず',
  '除いて',
  '近くに',
  '介して',
  'に向かって',
  'とは違って',
  '経由',
  '以内',
  '以外',
  'せずに',
  'を除く',
  '代わりに',
  '前に',
  '限り',
  'だけでなく',
  'に加えて',
  'に代わって',
  'この',
  'その',
  'あの',
  'これらの',
  'それらの',
  'これ',
  'それ',
  'あれ',
];

const koreanFilterWords: string[] = [
  '에',
  '에서',
  '에게',
  '으로',
  '로',
  '까지',
  '와',
  '과',
  '을',
  '를',
  '이',
  '그',
  '저',
  '가',
  '로서',
  '의',
  '도',
  '은',
  '는',
  '그래',
  '하지만',
  '그럼',
  '그리고',
  '그리고',
  '그래서',
  '그래도',
  '야',
  '아',
  '라고',
  '만',
  '그러면',
  '그러면서',
  '그러니',
  '게',
  '만',
];

export const CREATE_GAME_FILTER_WORDS = [
  ...enFilterWords,
  ...traditionalChineseFilterWords,
  ...simplifiedChineseFilterWords,
  ...japaneseFilterWords,
  ...koreanFilterWords,
];
